import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CreateAccount } from '../../../core/routing/interfaces/create-account.i';
import { CreateAccountService } from '../../../core/routing/services/createAccount/create-account.service';
import { IPOSValidator } from '../../../common/validators/validators';
import { countryConstants } from '../../../core/routing/constants/country.constant';
import { CreateAccountConstants } from './constants/create-account.const';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { faEye, faEyeSlash, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ConfirmRegistrationConstants } from '../confirm-registration/constants/confirm-registration.constant';
import { DataService } from '../../../core/data/data-service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { ConnectedUserAttributes, CreateConnectedAccountRequest, CreateNonConnectedAccountRequest, CreateAuthorAccountRequest } from './interfaces/create-account.i';
import { first } from 'rxjs/internal/operators/first';
import { GlobalConstants } from '../../../common/constants/global.constant';
import {NgbPopover } from '@ng-bootstrap/ng-bootstrap/popover/popover';
import { Base64 } from 'js-base64';

@Component({
  selector: 'iposcen-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
  creatAccForm: FormGroup;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faExclamationCircle = faExclamationCircle;
  createAccount: CreateAccount = new CreateAccount();
  countries = [] as any;
  errorMessage: string;
  isSubmitted = false;
  PAT_EMAIL = IPOSValidator.EMAIL;
  PAT_PASSWORD = IPOSValidator.PASSWORD_REGEX;
  mandatoryEmail: string;
  mandatoryFirstName: string;
  mandatoryLastName: string;
  mandatoryCountrySelect: string;
  mandataoryManufacturer: string;
  mandatoryPassword: string;
  mandatoryConfPassword: string;
  mandatoryRetailerName: string;
  mandatoryStoreName: string;
  mandatoryfield: string;
  mandatoryEmailValid: string;
  mandatoryIndicates: string;
  mandatoryCreateAccount: string;
  mandatoryPasswordMatch: string;
  placeholderEmail: string;
  placeholderComment: string;
  placeholderFirstName: string;
  placehoiderLastName: string;
  placeholderRetailerName: string;
  placeholderStoreName; string;
  placeholderPassword: string;
  placeholderCnfPassword: string;
  defaultText: string;
  pwdLength: string;
  fieldTextType: boolean;
  repeatFieldTextType: boolean;
  displayEyePassword: IconDefinition;
  displayEyeCnfPassword: IconDefinition;
  loginhref: string;
  disableButton: boolean;
  isUpperCase:boolean;
  isLowerCase:boolean;
  isNumeric:boolean;
  isSymbol:boolean;
  isMaxChar:boolean;
  isPasswordMatch:boolean;
  isChar:boolean;
  dsiplayError = true;
  receivedConnectedUserAttributes: ConnectedUserAttributes;
  isDisabled: boolean = false; 
  getCountry: string;  
  errorMsg: string;
  getRole: string;
  getPartnerName: string;
  isAuthorRole: boolean = false;
  private ngUnsubscribe = new Subject<boolean>();
  

  constructor(
    private createUserService: CreateAccountService,
    private formBuilder: FormBuilder,
    private router: Router,
    private dataService: DataService   
  ) { }
  openPop(p: NgbPopover){
    p.open();
  }
  ngOnInit(): void {
    this.getCountry = '';
    this.dataService.getQueryParameters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((getQueryParams) => {        
        this.receivedConnectedUserAttributes = getQueryParams;        
        if(this.receivedConnectedUserAttributes){               
          this.dataService.setIsUserConnected(true);   
          this.isDisabled = true;  
          this.getCountry = this.receivedConnectedUserAttributes.location;
          this.getRole = this.receivedConnectedUserAttributes.role;
          this.getPartnerName = this.receivedConnectedUserAttributes.partnerName;
        }
    });

    this.errorMessage = undefined;
    this.disableButton = false;
    this.getcreatAccForm();
    this.getCountries();
    this.disableBtn();
    this.displayEyePassword = faEye;
    this.displayEyeCnfPassword = faEye;
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.pwdLength = CreateAccountConstants.PASSWORD_MIN_LENGTH;
    this.defaultText = CreateAccountConstants.MANDADTORY_COUNTRY_DEFAULT;   
    this.mandatoryFirstName = CreateAccountConstants.MANDADTORY_FIRSTNAME;
    this.mandatoryLastName = CreateAccountConstants.MANDADTORY_LASTNAME;
    this.mandatoryEmail = CreateAccountConstants.MANDADTORY_EMAIL;
    this.mandatoryEmailValid = CreateAccountConstants.MANDADTORY_VALID_EMAIL;
    this.placeholderEmail = CreateAccountConstants.MANDADTORY_WORK_EMAIL;
    this.placeholderComment = CreateAccountConstants.PLACEHOLDER_COMMENTS;
    this.placeholderFirstName = CreateAccountConstants.PLACEHOLDER_FIRSTNAME;
    this.placehoiderLastName = CreateAccountConstants.PLACEHOLDER_LASTNAME;
    this.placeholderPassword = CreateAccountConstants.PLACEHOLDER_PASSWORD;
    this.placeholderCnfPassword = CreateAccountConstants.PLACEHOLDER_CNFPASSWORD;
    this.placeholderRetailerName = CreateAccountConstants.PLACEHOLDER_RETAILER_NAME;
    this.placeholderStoreName = CreateAccountConstants.PLACEHOLDER_STORENAME;
    this.mandatoryPassword = CreateAccountConstants.MANDADTORY_PASSWORD;
    this.mandatoryConfPassword = CreateAccountConstants.MANDADTORY_CNFPASSWORD;
    this.mandatoryCountrySelect = CreateAccountConstants.MANDADTORY_COUNTRY;
    this.mandataoryManufacturer = CreateAccountConstants.MANDATORY_MANUFACTURER;
    this.mandatoryRetailerName =
      CreateAccountConstants.MANDADTORY_RETAILER_NAME;
    this.mandatoryfield = CreateAccountConstants.MANDADTORY_REQUIRED_FIELD;
    this.mandatoryStoreName = CreateAccountConstants.MANDADTORY_STORENAME;
    this.mandatoryIndicates =
      CreateAccountConstants.MANDADTORY_INDICATES_HEADING;
    this.mandatoryCreateAccount =
      CreateAccountConstants.MANDADTORY_CREATE_ACCOUNT;
    this.mandatoryPasswordMatch =
      CreateAccountConstants.MANDATORY_PASSWORD_MATCH;
    sessionStorage.setItem('email', this.creatAccForm.get('email').value);    
    if(this.getRole === CreateAccountConstants.AUTHOR_ROLE) {
      this.isAuthorRole = true;
    }
  }

  getcreatAccForm() {
    this.creatAccForm = this.formBuilder.group(
      {
        firstName: new FormControl('', [Validators.required]),
        lastName: new FormControl('', [Validators.required]),
        email: new FormControl({ value: (this.receivedConnectedUserAttributes)? this.receivedConnectedUserAttributes.email:'', disabled: this.isDisabled}, [
          Validators.required,
          Validators.pattern(this.PAT_EMAIL)
        ]),
        password: new FormControl('', [
          Validators.required,
          // Validators.pattern(this.PAT_PASSWORD),
        ]),
        cnfPassword: new FormControl('', [
          Validators.required
        ]),
        countrySelect: new FormControl({ value:'', disabled: this.isDisabled}, [
          Validators.required]),
        retailerName: new FormControl({ value: (this.receivedConnectedUserAttributes)? this.receivedConnectedUserAttributes.retailerName:'', disabled: this.isDisabled}),
        storeName: new FormControl({ value: (this.receivedConnectedUserAttributes)? this.receivedConnectedUserAttributes.storeName:'', disabled: this.isDisabled}),
        comments: new FormControl(''),
        manufacturer: new FormControl({ value: (this.receivedConnectedUserAttributes)? this.receivedConnectedUserAttributes.partnerName:'', disabled: this.isDisabled})
      },
      {
        validator: IPOSValidator.confirmedValidator('password', 'cnfPassword')
      }
    );
    //To empty the storeName placeholder input when StoreName value is blank in  account
    if(this.receivedConnectedUserAttributes && this.receivedConnectedUserAttributes?.storeName == ""){
      this.placeholderStoreName = '';
    }
  }

  get formControls() {
    return this.creatAccForm.controls;
  }

  /*onRegister() {
    this.isSubmitted = true;
    if (this.creatAccForm.invalid) {
      return;
    }
    this.errorMessage = undefined;
    this.createAccount.firstName = this.creatAccForm.get('firstName').value;
    this.createAccount.lastName = this.creatAccForm.get('lastName').value;
    this.createAccount.email = this.creatAccForm.get('email').value;
    this.createAccount.password = this.creatAccForm.get('password').value;
    this.createAccount.cnfPassword = this.creatAccForm.get('cnfPassword').value;
    this.createAccount.countrySelect = this.creatAccForm.get(
      'countrySelect'
    ).value;
    this.createAccount.retailerName = this.creatAccForm.get(
      'retailerName'
    ).value;
    this.createAccount.storeName = this.creatAccForm.get('storeName').value;
    this.createAccount.comments = this.creatAccForm.get('comments').value;
    this.createUserService.register(this.createAccount, this);
    sessionStorage.setItem('firstName', this.createAccount.firstName);
    sessionStorage.setItem('email', this.createAccount.email);
    //gtm(google tag manager)
    window['dataLayer'].push({
      'account_requested':true
      });
  } */

  getCountries() {
    countryConstants.forEach(element => {
      const country = {
        CountryName: element.CountryName
      };
      this.countries.push(country);
    });
  }

  disableBtn() {
    this.disableButton = false;
    if (this.creatAccForm.get('firstName').value.trim().length > 0 && this.creatAccForm.get('lastName').value.trim().length > 0 && this.creatAccForm.get('email').value
      && this.creatAccForm.get('password').value && this.creatAccForm.get('cnfPassword').value &&
      this.creatAccForm.get('countrySelect').value && (this.isAuthorRole? this.creatAccForm.get('manufacturer').value.trim().length > 0 : this.creatAccForm.get('retailerName').value.trim().length > 0)) {
      this.disableButton = true;
      this.isMaxChar = true;
    } else {
      this.disableButton = false;
      this.isMaxChar = false;
    }

  }

  trackByCountry(index: number, el: string): number {
    return index;
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
    if (this.fieldTextType) {
      this.displayEyePassword = faEyeSlash;
    } else if (!this.fieldTextType) {
      this.displayEyePassword = faEye;
    }
  }
  toggleRepeatFieldTextType() {
    this.repeatFieldTextType = !this.repeatFieldTextType;
    if (this.repeatFieldTextType) {
      this.displayEyeCnfPassword = faEyeSlash;
    } else if (!this.repeatFieldTextType) {
      this.displayEyeCnfPassword = faEye;
    }
  }

 /* cognitoCallback(message: string, result: any) {
    if (message !== undefined) {
      // error
      if (message === CreateAccountConstants.USER_ALREADY_EXISTS) {
        this.errorMessage = CreateAccountConstants.USER_ALREADY_EXISTS_ID;
      } else {
        this.errorMessage = message;
      }
    } else {
      // success
      // move to the next step
      this.router.navigate([
        RouterConstants.CONFIRM_REGISTRATION_LINK,
        this.creatAccForm.get('email').value
      ]);
    }
  } */
  checkPasswordValidation(pwdValue,p:NgbPopover) {
    p.open();
    this.isNumeric = /(?=.*\d)/.test(pwdValue);
    this.isUpperCase = /(?=.*[A-Z])/.test(pwdValue);
    this.isLowerCase = /(?=.*[a-z])/.test(pwdValue);
    this.isSymbol = GlobalConstants.ISSYMBOL.test(pwdValue);
    this.isMaxChar = pwdValue.length > 7 ? true : false;
    this.dsiplayError = !(this.isNumeric && this.isUpperCase && this.isLowerCase && this.isSymbol && this.isMaxChar);
  }

  checkCnfPasswordValidation(cnfpwdValue,cnfpwdPopup:NgbPopover){
    cnfpwdPopup.open();
    if(this.creatAccForm.controls.password.value === cnfpwdValue && cnfpwdValue !=="")     {
     this.isPasswordMatch = true;
    } else {
      this.isPasswordMatch = false;
    }
    
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onClickCreateAccount() {
    if (this.dsiplayError) {
      return false;
    }
    if (this.receivedConnectedUserAttributes) {
      if(this.getRole === CreateAccountConstants.AUTHOR_ROLE) {
        this.createAuthorAccount();
    } else if(this.getRole !== CreateAccountConstants.AUTHOR_ROLE) {
      this.createConnectedAccount();
    }
    } else {
     // this.onRegister();
     this.createNonConnectedAccount();
    }
  }

  createNonConnectedAccount() {
    this.isSubmitted = true;
    if (this.creatAccForm.invalid) {
      return;
    }
    this.errorMessage = undefined;
    const createNonConnectedAccountRequestObj: CreateNonConnectedAccountRequest = {
      email: this.creatAccForm.get('email').value,
      firstName: this.creatAccForm.get('firstName').value,
      lastName: this.creatAccForm.get('lastName').value,
      location: this.creatAccForm.get('countrySelect').value,
      language: localStorage.getItem('preferredLanguageAccCreation'),
      retailerName: this.creatAccForm.get('retailerName').value,
      storeName: this.creatAccForm.get('storeName').value,
      configurations: JSON.stringify({comments: this.creatAccForm.get('comments').value, email_notifications: 'yes'}),
      password: Base64.encode(this.creatAccForm.get('password').value)
    };
    sessionStorage.setItem('firstName', this.creatAccForm.get('firstName').value);
    sessionStorage.setItem('email', this.creatAccForm.get('email').value);
    sessionStorage.setItem('createNonConnectedUser', JSON.stringify(createNonConnectedAccountRequestObj));
    this.createUserService.createNonConnectedAccount(createNonConnectedAccountRequestObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createAccountResponse => {
        if (createAccountResponse.user.userID) {
          sessionStorage.setItem('userId', createAccountResponse.user.userID);
        }
          this.router.navigate([
            RouterConstants.CONFIRM_REGISTRATION_LINK,
            this.creatAccForm.get('email').value
          ]);
        window['dataLayer'].push({
          'account_requested': true
      });
      },
        error => {
          if (error.responseContext.exceptionResponse.errorDetails === CreateAccountConstants.USER_ALREADY_EXISTS) {
            this.errorMessage = CreateAccountConstants.USER_ALREADY_EXISTS_ID;
        }
        }
      );
  }

  createConnectedAccount() {
    this.isSubmitted = true;
    if (this.creatAccForm.invalid) {
      return;
    }
    this.errorMessage = undefined;
    const createConnectedAccountRequestObj: CreateConnectedAccountRequest = {
      email: this.creatAccForm.get('email').value,
      firstName: this.creatAccForm.get('firstName').value,
      lastName: this.creatAccForm.get('lastName').value,
      location: this.creatAccForm.get('countrySelect').value,
      language: localStorage.getItem('preferredLanguageAccCreation'),
      createdByUserID: this.receivedConnectedUserAttributes.createdByUserID,
      createdByName: this.receivedConnectedUserAttributes.createdByName,
      role: this.receivedConnectedUserAttributes.role,
      retailerName: this.creatAccForm.get('retailerName').value,
      retailerID: this.receivedConnectedUserAttributes.retailerID,
      storeID: this.receivedConnectedUserAttributes.storeID,
      storeName: this.receivedConnectedUserAttributes.storeName,
      configurations: JSON.stringify({comments: this.creatAccForm.get('comments').value, email_notifications: 'yes'}),
      password: Base64.encode(this.creatAccForm.get('password').value)
    };
    sessionStorage.setItem('firstName', this.creatAccForm.get('firstName').value);
    sessionStorage.setItem('email', this.creatAccForm.get('email').value);

    this.createUserService.createAccountByInvite(createConnectedAccountRequestObj, this.receivedConnectedUserAttributes.createdByUserID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createAccountResponse => {
        if (createAccountResponse.user[0]?.userID) {
          sessionStorage.setItem('userId', createAccountResponse.user[0].userID);
        }
        this.router.navigate([
          RouterConstants.CONFIRM_REGISTRATION_LINK,
          this.creatAccForm.get('email').value
        ]);
        // if (createAccountResponse.user[0].userStatus === CreateAccountConstants.CREATED_USER_STATUS_ACTIVE){          
        //   this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_ACTIVE]);
        // }else{
        //   this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_PENDING]);
        // }      
      },
        error => {
          if (error.responseContext.exceptionResponse.errorDetails === CreateAccountConstants.USER_ALREADY_EXISTS) {
            this.errorMessage = CreateAccountConstants.USER_ALREADY_EXISTS_ID;
          }
        }
      );
  }

  createAuthorAccount() {
    this.isSubmitted = true;
    if (this.creatAccForm.invalid) {
      return;
    }
    this.errorMessage = undefined;
    const createAuthorAccountRequestObj: CreateAuthorAccountRequest = {
      email: this.creatAccForm.get('email').value,
      firstName: this.creatAccForm.get('firstName').value,
      lastName: this.creatAccForm.get('lastName').value,
      location: this.creatAccForm.get('countrySelect').value,
      language: localStorage.getItem('preferredLanguageAccCreation'),
      createdByUserID: this.receivedConnectedUserAttributes.createdByUserID,
      createdByName: this.receivedConnectedUserAttributes.createdByName,
      role: this.receivedConnectedUserAttributes.role,
      partnerName: this.creatAccForm.get('manufacturer').value,
      partnerID: this.receivedConnectedUserAttributes.partnerID,
      configurations: JSON.stringify({comments: this.creatAccForm.get('comments').value, email_notifications: 'yes'}),
      password: Base64.encode(this.creatAccForm.get('password').value)
    };
    sessionStorage.setItem('firstName', this.creatAccForm.get('firstName').value);
    sessionStorage.setItem('email', this.creatAccForm.get('email').value);

    this.createUserService.createAccountByInvite(createAuthorAccountRequestObj, this.receivedConnectedUserAttributes.createdByUserID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createAccountResponse => {
        if (createAccountResponse.user[0].userID) {
          sessionStorage.setItem('userId', createAccountResponse.user[0].userID);
        }        
        this.router.navigate([
          RouterConstants.CONFIRM_REGISTRATION_LINK,
          this.creatAccForm.get('email').value
        ]);
        // if (createAccountResponse.user[0].userStatus === CreateAccountConstants.CREATED_USER_STATUS_ACTIVE){          
        //   this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_ACTIVE]);
        // }else{
        //   this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_PENDING]);
        // }      
      },
        error => {
          if (error.responseContext.exceptionResponse.errorDetails === CreateAccountConstants.USER_ALREADY_EXISTS) {
            this.errorMessage = CreateAccountConstants.USER_ALREADY_EXISTS_ID;
          }
        }
      );
  }
}
